// src/components/customers/tabs/tabs-UnpaidInvoices.jsx
import React from "react";
import { useCustomerUnpaidInvoicesQuery } from "@queries/customers";

const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
};

export default function UnpaidInvoicesTab({ customer }) {
  const id = customer?.customer_id || customer?.id;
  const { data, isLoading, isError } = useCustomerUnpaidInvoicesQuery(id);

  if (isLoading) return <div className="oc-empty">Loading unpaid invoices…</div>;
  if (isError)
    return <div className="oc-empty" style={{ color: "red" }}>Error loading unpaid invoices</div>;

  const orders = data?.orders || [];
  const total = Number(data?.total ?? 0);

  return (
    <div className="oc-card">
      <div
        className="oc-header"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <h2 style={{ color: "#dc2626" }}>Total unpaid invoices</h2>
        <div style={{ fontSize: 22, fontWeight: 800, color: "#dc2626" }}>
          {total.toFixed(3)} JOD
        </div>
      </div>

      <div style={{ padding: "0 4px 8px", color: "#6b7280", fontSize: 12 }}>
        Sum of orders in <b>Cleaning</b> and <b>Delivery</b> status. Complementary
        (comped) orders are shown greyed out and are <b>not</b> counted.
      </div>

      <div className="oc-table-wrap">
        <table className="oc-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Status</th>
              <th>Type</th>
              <th>Order Date</th>
              <th>Dropoff Date</th>
              <th style={{ textAlign: "right" }}>Amount (JOD)</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center", padding: 24 }}>
                  No unpaid invoices.
                </td>
              </tr>
            ) : (
              orders.map((o) => {
                const excluded = o.complementary;
                return (
                  <tr
                    key={o.order_id}
                    style={excluded ? { backgroundColor: "#efd9d9", color: "#9ca3af" } : undefined}
                  >
                    <td>
                      <a href={`/orders/${o.order_id}`} target="_blank" rel="noreferrer">
                        {o.order_id}
                      </a>
                      {o.invoice_label ? ` (${o.invoice_label})` : ""}
                    </td>
                    <td>{o.status_name || o.order_status_id}</td>
                    <td>
                      {o.order_type || "—"}
                      {excluded ? (
                        <span
                          title={o.complemantary_reason}
                          style={{
                            marginLeft: 6,
                            fontSize: 10,
                            fontWeight: 700,
                            color: "#b91c1c",
                            border: "1px solid #b91c1c",
                            borderRadius: 4,
                            padding: "0 4px",
                          }}
                        >
                          COMPLEMENTARY
                        </span>
                      ) : null}
                    </td>
                    <td>{fmtDate(o.date_added)}</td>
                    <td>{fmtDate(o.dropoff_date)}</td>
                    <td style={{ textAlign: "right", textDecoration: excluded ? "line-through" : "none" }}>
                      {Number(o.total || 0).toFixed(3)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
          {orders.length > 0 && (
            <tfoot>
              <tr>
                <td colSpan={5} style={{ textAlign: "right", fontWeight: 700 }}>
                  Total unpaid
                </td>
                <td style={{ textAlign: "right", fontWeight: 800, color: "#dc2626" }}>
                  {total.toFixed(3)}
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}
